<template>
  <div class="af-account">
    <a-input-search class="input-search" placeholder="请输入要搜索的产品名称" @search="search" />
    <a-button type="primary" class="bind-btn" @click="bindAccount">关联账号</a-button>
  	<a-table
      :columns="columns"
      :row-key="(record, index) => index"
      :data-source="data"
      :pagination="pagination"
      size="small"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="handle" slot-scope="text, record">
        <a-popconfirm
          title="解除关联后系统中将不会再统计该账号数据，请确认是否解除关联。"
          ok-text="确定"
          cancel-text="取消"
          @confirm="unbindClick(record)"
        >
          <icon-font class="unbind-btn" type="icon-Disconnect"/>
        </a-popconfirm>
      </template>
      <template slot="index" slot-scope="text, record, index">
        <span>{{index + 1}}</span>
      </template>
    </a-table>
    <a-modal
      title="关联产品"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="visible = false"
      width="480px"
    >
      <a-form-model ref="form" :model="form" :rules="rules" 
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        class="third-bind-form"
      >
        <a-form-model-item label="API_token" prop="accessToken">
          <a-input v-model="form.accessToken"/>
        </a-form-model-item>
        <a-form-model-item label="产品名称" prop="productName">
          <a-input v-model="form.productName"/>
        </a-form-model-item>
        <a-form-model-item label="包名" prop="productPkg">
          <a-input v-model="form.productPkg"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { getAfProducts, thirdBind, thirdUnbind } from "@/api/mediadata"

const columns = [
	{
		title: '产品名称',
		dataIndex: 'productName',
		width: 150,
		align: 'center',
	},
	{
		title: '包名',
		dataIndex: 'productPkg',
		align: 'center',
		width: 215,
	},
		{
		title: '关联时间',
		dataIndex: 'createTime',
		align: 'center',
		width: 151,
	},
	{
		title: '操作人',
		dataIndex: 'operator',
		align: 'center',
		width: 151,
	},
  {
		title: '操作',
		dataIndex: 'handle',
		align: 'center',
		scopedSlots: { customRender: 'handle' },
		width: 151,
	},
]
export default {
	name: 'MediaData',
	data() {
		return {
      code: 'AF',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
			columns,
      visible: false,
      form: {
        tokenVer: 'V1.0',
        productName: '',
        productPkg: '',
        accessToken: ''
      },
      rules: {
        accessToken: [{ required: true, message: '请输入API_token', trigger: 'blur' }],
        productName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        productPkg: [{ required: true, message: '请输入包名', trigger: 'blur' }],
      },
      confirmLoading: false
		}
	},
  methods: {
    handleOk() {
      this.$refs.form.validate(valid => {
        if(!valid) return ;
        this.confirmLoading = true;
        thirdBind({
          ...this.form,
          mediaCode: this.code
        }).then((res) => {
          this.$message.success('关联成功！')
          this.getList()
          this.visible = false
        }).finally(() => this.confirmLoading = false)
      })
    },
    search(value) {
      this.pagination.current = 1
      this.getList(value)
    },
    // 绑定账号
    bindAccount() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    // 解绑账号
    unbindClick(record) {
      thirdUnbind({
        mediaCode: this.code,
        productPkg: record.productPkg,
        tokenVer: record.tokenVer,
      }).then((res) => {
        this.$message.success('解绑成功！')
        this.getList()
      })
    },
    getList(searchKeyWord) {
      this.loading = true
      getAfProducts({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        searchKeyWord
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.getList()
		},
  },
  mounted() {
    this.getList()
  }
}
</script>
<style lang="less">
.af-account {
  position: relative;
  .input-search {
    width: 258px;
    top: -53px;
    position: absolute;
    right: 120px;
  }
  .bind-btn {
    top: -53px;
    position: absolute;
    right: 24px;
  }
}
.third-bind-form {
  .ant-form-item-required{
    font-weight: normal;
    &::before {
      display: none;
    }
  }
}
</style>